import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';
import { HelpersService } from '@evento-ng/libs';
import { TicketService } from 'src/app/shared/services/ticket.service';
@Component({
  selector: 'app-sport-ticket-card',
  templateUrl: './sport-ticket-card.component.html',
  styleUrls: ['./sport-ticket-card.component.scss'],
})
export class SportTicketCardComponent {
  @Input() ticket: any;
  @Input() match: any;
  counter = 0;
  item: any;
  albums: any = [];
  isMobile = false;
  constructor(
    public translate: TranslateService,
    public ticketService: TicketService,
    public fb: FormBuilder,
    private router: Router,
    public helpers: HelpersService
  ) {
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  deleteItem(): void {
    this.counter = 0;
    this.ticketService.deleteItem(this.item);
  }

  ngOnChanges() {
    this.counter = 0;
    this.ticketService.bookTicket$
      .pipe(
        tap((res) => {
          const ticket = res?.items?.find((x) => {
            if (x.ticket.id === this.ticket.id) {
              return x;
            }
          });
          if (ticket) {
            this.counter = ticket.quantity;
          }
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.ticketService.ItemDeleted.subscribe((res: any) => {
      if (this.ticket.id == res.ticket.id) {
        this.counter = 0;
      }
    });
    if (this.router.url.includes('sport')) {
      this.ticketService.bookTicket$.subscribe((res: any) => {
        if (this.ticket.id != res?.items?.[0]?.ticket?.id) {
          this.counter = 0;
        }
      });
    }

    if (this.ticket?.attachments?.length > 0) {
      for (let i = 0; i < this.ticket.attachments.length; i++) {
        const src = this.ticket.attachments[i].url;
        const album = {
          src: src,
        };

        this.albums.push(album);
      }
    }

    this.initForm();
  }

  private initForm(): void {
    const bookTicket = this.ticketService.bookTicket.getValue();
    this.item = bookTicket?.items?.find((x) => x.ticket.id === this.ticket.id);
  }

  increaseCount(): void {
    if (this.ticket.minimumPerOrder > this.counter) {
      this.counter = this.ticket.minimumPerOrder;
      this.onCounterChanged();
      return;
    }
    this.counter = this.counter + 1;
    this.onCounterChanged();
  }

  decreaseCount(): void {
    if (1 > this.counter) {
      this.counter = 1;
      this.onCounterChanged();
      return;
    }
    this.counter = this.counter - 1;
    this.onCounterChanged();
  }

  increaseCountEnabled() {
    if (this.ticket.maxTicketQuantity > this.counter) {
      return true;
    } else {
      return false;
    }
  }

  onCouterChangedSport() {
    if (this.item) {
      this.onCounterChangedEvents();
    } else {
      if (this.ticketService.bookTicket.getValue()?.items?.length > 0) {
        this.ticketService.bookTicket.next(null);
        this.ticketService.updateBookTicketItems({
          ticket: this.ticket,
          quantity: 1,
          date: this.match.date,
          time: this.match.time,
        });
      } else {
        this.onCounterChangedEvents();
      }
    }
  }

  onCounterChanged(): void {
    this.item = this.ticketService.bookTicket
      .getValue()
      ?.items?.find((x) => x.ticket.id === this.ticket.id);

    if (this.router.url.includes('sport')) {
      this.onCouterChangedSport();
    } else {
      this.onCounterChangedEvents();
    }
  }

  onCounterChangedEvents() {
    this.ticketService.updateBookTicketItems({
      ticket: this.ticket,
      quantity: this.counter,
      date: this.match.date,
      time: this.match.time,
    });
    if (this.item) {
      this.ticketService.updateBookTicketItems({
        ticket: this.ticket,
        quantity: this.counter,
      });
    }
  }
}
